import { render, staticRenderFns } from "./equipmentParameters.vue?vue&type=template&id=21471108&scoped=true&"
import script from "./equipmentParameters.vue?vue&type=script&lang=js&"
export * from "./equipmentParameters.vue?vue&type=script&lang=js&"
import style0 from "./equipmentParameters.vue?vue&type=style&index=0&id=21471108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21471108",
  null
  
)

export default component.exports